import {AllModeDataType, ModeDataType, UnitType} from '@/types/homework'
import {QuePubType} from '@/types/question'
import {MODE} from '@/utils/const'
import {QuesIdsType} from '../../types/homework'
export const defSections = {
	id: 0,
	name: '全部课时',
	orders: 0
}
export const defQuesType = {
	biz: 0,
	name: '全部题型'
}

export const initModeData: ModeDataType = {
	book_id: 0,
	class_id: 0,
	category_id: 0,
	grade_name: '',
	name: '',
	unit_id: 0,
	section: defSections,
	que_type: defQuesType,
	grade: {
		id: 0,
		name: ''
	},
	category: {
		id: 0,
		name: ''
	},
	filter_published: false,
	total: 0,
	time: 0,
	section_id: 0,
	content: [
		{
			exam_id: 0,
			have_vip: false,
			master_exam_id: 0,
			questions: []
		}
	],
	book_info: []
}
const homeworkDefaultState = {
	mode: '' as MODE,
	data: {} as AllModeDataType,
	ques: [] as QuePubType[],
	unit_list: [] as UnitType[],
	unit_loading: false,
	ques_loading: false,
	que_page: 1,
	que_total: 0,
	que_load_end: false,
	que_ids: [] as QuesIdsType[],
	que_limit: 5,
	area_list: []
}

export type HomeworkDefaultStateType = typeof homeworkDefaultState

export default homeworkDefaultState
